import { useState, useEffect } from "react";
import { filterAfterChangeEventKey } from "./useFilter";

export function useUrls() {
  const [params, setParams] = useState(window.location.search);

  useEffect(() => {
    const onFilterChange = () => {
      setParams(window.location.search);
    };
    document.addEventListener(filterAfterChangeEventKey, onFilterChange);
    return () => {
      document.removeEventListener(filterAfterChangeEventKey, onFilterChange);
    };
  });

  return {
    home: {
      url: process.env.HOME_URL?.concat(params),
      thumbnailLight: `${process.env.ASSET_PATH || ""}/img/menu/map-light.svg`,
      thumbnailDark: `${process.env.ASSET_PATH || ""}/img/menu/map-dark.svg`,
      title: "Trade partner map",
      description:
        "Track the leading trading economies as they change over time.",
      headline: "Who is the top trading partner of each economy?",
      dek: "",
    },
    "trade-network": {
      url: process.env.TRADE_NETWORK_URL?.concat(params),
      thumbnailLight: `${
        process.env.ASSET_PATH || ""
      }/img/menu/network-light.svg`,
      thumbnailDark: `${
        process.env.ASSET_PATH || ""
      }/img/menu/network-dark.svg`,
      title: "Global trade network",
      description: "View global trade flows across sectors and years",
      headline: "What are the most important trade corridors?",
      dek: "Global flows travel through corridors that connect countries, shaping the global economy—from oil flows from the Middle East, to power from East Asia, to agriculture flows from the Americas to the rest of the world. Explore the data to identify the major players in the global trade network in different subsectors",
    },
    "trade-composition": {
      url: process.env.TRADE_COMPOSITION_URL?.concat(params),
      thumbnailLight: `${
        process.env.ASSET_PATH || ""
      }/img/menu/composition-light.svg`,
      thumbnailDark: `${
        process.env.ASSET_PATH || ""
      }/img/menu/composition-dark.svg`,
      title: "Trade composition",
      description:
        "See a breakdown of imports and exports across sectors for an economy",
      headline:
        "What are the main traded sectors and who are the main trade partners of an economy?",
      dek: "The trade profile of economies constantly evolves. Explore the data to understand how the composition of exports and imports has been changing in different sectors and among trade partners over time.",
    },
    "trading-partners": {
      url: process.env.TRADING_PARTNERS_URL?.concat(params),
      thumbnailLight: `${
        process.env.ASSET_PATH || ""
      }/img/menu/evolution-light.svg`,
      thumbnailDark: `${
        process.env.ASSET_PATH || ""
      }/img/menu/evolution-dark.svg`,
      title: "Evolution in trade partners",
      description:
        "See how an economy’s trade have evolved with its top trading partners",
      headline: "How has trade between economies evolved over time?",
      dek: "Over the past few years, leading economies have reconfigured their main trading partners. Explore for which economies and for which sectors trading partners are changing in this shifting trade landscape.",
    },
    interdependencies: {
      url: process.env.INTERDEPENDENCIES_URL?.concat(params),
      thumbnailLight: `${
        process.env.ASSET_PATH || ""
      }/img/menu/interdependencies-light.svg`,
      thumbnailDark: `${
        process.env.ASSET_PATH || ""
      }/img/menu/interdependencies-dark.svg`,
      title: "Trade interdependencies",
      description: "View trade interdependencies between two economies",
      headline: "How interdependent are two economies?",
      dek: "No region is self-sufficient in today’s interconnected world. Every region relies on trade with others, both as markets and suppliers in numerous categories. Understand the degree of interdependence of pairs of economies by comparing their import and export relationships across sectors.",
    },
    "product-concentration": {
      url: process.env.PRODUCT_CONCENTRATION_URL?.concat(params),
      thumbnailLight: `${
        process.env.ASSET_PATH || ""
      }/img/menu/concentration-light.svg`,
      thumbnailDark: `${
        process.env.ASSET_PATH || ""
      }/img/menu/concentration-dark.svg`,
      title: "Product concentration",
      description:
        "Understand which product imports are supplied by a small number of economies",
      headline: "Which products are supplied by a small number of economies?",
      dek: "Global interconnections have created broad economic benefits, but recent supply chain disruptions have highlighted the importance of resilience. Concentrated global trade can create complication if products are harder to replace on short notice. However, not all concentration is the same. Explore where concentrated trading relationships exist.",
    },
  };
}
